import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';

import {
    ButtonComponent,
    ContainerComponent,
    IconComponent,
    IFooter,
    IFooterSimple,
    ILogo,
    ISocialMediaItem,
    PAGE_SERVICE,
    SocialMediaIconService,
} from '@sirius/common';
import { PsbButtonDirective } from '../../../directives/psb-button/psb-button.directive';
import { PageDefaultService } from '../../../services';

@Component({
    selector: 'butterfly-footer-simple',
    imports: [IconComponent, ButtonComponent, ContainerComponent, PsbButtonDirective],
    templateUrl: './footer-simple.component.html',
    styleUrl: './footer-simple.component.scss',
    host: { class: 'sir-text-style-paragraph-m-default' },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterSimpleComponent implements OnInit {
    pageService = inject<PageDefaultService>(PAGE_SERVICE);

    @Input({ required: true }) logo!: ILogo;
    @Input({ required: true }) socialMediaLinks!: ISocialMediaItem[];
    @Input({ required: true }) footer!: IFooter;
    @Input() culture?: string;

    config?: IFooterSimple;
    currentYear = new Date().getFullYear();
    isChina = false;

    private _socialMediaIconService = inject(SocialMediaIconService);


    ngOnInit(): void {
        if (this.config) {
            this.socialMediaLinks = this.config.socialMediaLinks;
            this.footer = this.config.footer;
        }

        this.isChina = this.culture === 'zh-Hans';

        this.getSoMeIcons();
    }

    private getSoMeIcons() {
        this.socialMediaLinks.forEach(
            (x: ISocialMediaItem) =>
                (x.icon = this._socialMediaIconService.getIconName(x.itemType)),
        );
    }
}
